import gql from 'graphql-tag';
import channelInfoFragment from '../../fragments/channel/channelInfo';

export default gql`
  fragment communityChannelConnection on Community {
    channelConnection {
      edges {
        node {
          ...channelInfo
        }
      }
    }
  }
  ${channelInfoFragment}
`;
